module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAuklEQVR42mMwNv7PQAvMQA+D3wLxfih+h8QmhJHVvsVm8H4ozQjE+6DsOCCuw4HjoGr2QfUgm0HQYAMgdsSBDSgxmBg8ajDpBoPwCSBmIcJQFqhaBmINjoVqIJSGT0DVEm0wuZigwfJA3EAklifFYHsgXgDEDkgZwgEqjowXQGmSDAa5Jh6Ir0FjvhyL1xsoMTgBT5gOU4MvArEYmsH6SKUY2QabQg0HSZ4H4ntEZJB7ULV4C/qhUecBABkjBK7OHRYVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/icons/floppy_disk.png
// module id = 1992
// module chunks = 2